import React from 'react';
import { Typography, Button, Dialog, DialogTitle, DialogActions, Box } from '@material-ui/core';

export interface IProps {
  open: boolean;
  onClose: () => void;
  onImport: (file: File) => void;
}

const ImportAnimalsDialog: React.FC<IProps> = ({ open, onClose, onImport }) => {
  const [file, setFile] = React.useState<File | null>(null);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleImportClick = () => {
    if (file) {
      onImport(file);
      setFile(null);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Import Animals</DialogTitle>

      {/* Dropzone */}
      <Box
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        sx={{
          border: '2px dashed #ccc',
          borderRadius: 2,
          p: 4,
          m: 2,
          textAlign: 'center',
          bgcolor: '#fafafa'
        }}
        component="label"
      >
        <input type="file" accept=".csv" hidden onChange={handleFileSelect} />

        <Typography variant="body2" color="textSecondary" style={{ cursor: 'grab' }}>
          {file ? file.name : 'Select CSV file to upload or drag one here'}
        </Typography>
      </Box>

      <DialogActions>
        <Button onClick={handleImportClick} disabled={!file} variant="contained">
          Validate
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportAnimalsDialog;
